"use strict";
const domSymbolTree = require("./internal-constants").domSymbolTree;

exports.closest = (e, localName) => {
  while (e) {
    if (e.localName === localName) {
      return e;
    }
    e = domSymbolTree.parent(e);
  }

  return null;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/helpers/traversal.js
// module id = rF9h
// module chunks = 1